
    import {useStore} from "@/store";
    import common from "@/util/common";
    import reportMsgUt from "@/util/reportMsg";
    import DetectPlayer from '@/views/components/ALvideoPlayer/index.vue';
    import '@souche-ui/cyp_aliyunplayer/lib/styles/index.css';
    import {useRouter, useRoute} from "vue-router";
    import {defineComponent, computed, ComputedRef, watch, reactive, toRefs, ref, nextTick} from "vue";
    import {getVideoPlayAuth} from '@/service'
    interface State {
        playAuth: string;
        loopVideo: any;
        videoId: string;
        playData: any;
        reportMsg: object;
        videoInfo: any[];
        currentVideoIndex: number;
        showVideoModal: boolean;
    }

    export default defineComponent({
        name: "LoopCarVideoH5",
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        setup(props: any) {
            let state: State = reactive({
                playAuth: '',
                loopVideo: {},
                videoId: '',
                playData: null,
                reportMsg: {},
                videoInfo: [],
                currentVideoIndex: 0,
                showVideoModal: false,
            })
            const videoPlayerRef = ref<any>(null);
            let store = useStore()
            const router = useRouter();
            const {query} = useRoute();
            const {templateCode} = query;
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)

            state.reportMsg = reportMsgUt;
            const getPlayAuth = function (videoId) {
                videoId && getVideoPlayAuth({videoId}).then((res: any) => {
                    state.playAuth = res;
                    state.playData = {
                        playAuth: res,
                        vodId: state.videoId,
                        cover: state.loopVideo && state.loopVideo.videoFirstImg,
                        autoplay: false,
                        size: state.loopVideo && state.loopVideo.videoSize
                    }
                });
            };
            const VIDEO_CODE_MAP = {
                SV9: 'Exterior/Interior',
                SV7: 'Paint',
                SV11: 'Engine/Transmission',
                SV10: 'Chassis'
            };
            const VIDEO_CODE_ORDER = ['SV9', 'SV7', 'SV11', 'SV10'];
            watch(reportData, (data: any) => {
                const {videoInfo} = data
                // 仅展示视频列表，等用户点击后再加载对应视频
                // 后端会返回多个视频，仅需展示 VIDEO_CODE_ORDER 中的四个视频，name 取 VIDEO_CODE_MAP
                const orderSet = new Set(VIDEO_CODE_ORDER);
                state.videoInfo = (videoInfo || [])
                    .filter(v => v && orderSet.has(v.videoCode))
                    .sort((a, b) => VIDEO_CODE_ORDER.indexOf(a.videoCode) - VIDEO_CODE_ORDER.indexOf(b.videoCode))
                    .map(v => ({...v, videoName: VIDEO_CODE_MAP[v.videoCode]}));
            }, {immediate: true, deep: true})

            function switchTab(index) {
                state.currentVideoIndex = index;
                state.loopVideo = state.videoInfo[index];
                state.videoId = state.loopVideo && state.loopVideo.videoId;
                // 弹出弹层并加载对应视频
                state.showVideoModal = true;
                getPlayAuth(state.videoId);
            }

            // 关闭视频弹层：先销毁播放器再关闭弹层，回到视频列表
            function closeVideoModal() {
                if (videoPlayerRef.value) {
                    videoPlayerRef.value.clearAllData();
                }
                state.playData = null;
                state.showVideoModal = false;
            }

            // ios 下视频在原生全屏播放器中播放，用户点"完成"退出时触发 webkitendfullscreen，此时同步关闭弹层
            function bindIosCloseEvent() {
                const playerComp: any = videoPlayerRef.value;
                if (!playerComp) return;
                nextTick(() => {
                    const videoEl: any = playerComp.$el && playerComp.$el.querySelector('video');
                    if (videoEl && !videoEl.__modalCloseBound) {
                        videoEl.__modalCloseBound = true;
                        videoEl.addEventListener('webkitendfullscreen', () => {
                            closeVideoModal();
                        });
                    }
                });
            }

            // 播放器事件：ready 后给 video 绑定 ios 原生全屏关闭事件
            function onPlayerEvent(args: any) {
                if (args && args.eventType === 1) {
                    bindIosCloseEvent();
                }
            }

            return {
                state,
                router,
                store,
                getPlayAuth,
                switchTab,
                closeVideoModal,
                onPlayerEvent,
                videoPlayerRef
            }
        },
        components: {
            DetectPlayer
        }
    })
